// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-markdown {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 25%;
  z-index: 6;
  border-right: 1px solid var(--g-color-line-generic);
  background: var(--g-color-base-background);
  opacity: 0.9;
}
.side-markdown__close-button {
  position: absolute;
  top: 5px;
  right: 15px;
}
.side-markdown__body {
  height: 98%;
  width: 100%;
  padding: 10px;
  border: none;
  overflow-y: scroll;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/SideMarkdown/SideMarkdown.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,mDAAA;EACA,0CAAA;EACA,YAAA;AACJ;AACI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;AACR;AAEI;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AAAR","sourcesContent":[".side-markdown {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 25%;\n  z-index: 6;\n  border-right: 1px solid var(--g-color-line-generic);\n  background: var(--g-color-base-background);\n  opacity: 0.9;\n}\n.side-markdown__close-button {\n  position: absolute;\n  top: 5px;\n  right: 15px;\n}\n.side-markdown__body {\n  height: 98%;\n  width: 100%;\n  padding: 10px;\n  border: none;\n  overflow-y: scroll;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
